import DefaultLayout from 'layouts/DefaultLayout/DefaultLayout';
import React, { useEffect, useState } from 'react';
import { $api } from 'services/service';
import { setAlert, setLoading } from 'redux/authSlice';
import { useDispatch } from 'react-redux';
import DatePicker from 'react-datepicker';
import { Link, useHistory, useParams } from 'react-router-dom';
import Button from 'components/Elements/Button/Button';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Calendar from 'components/Elements/Calender/Calendar';
import moment from 'moment-timezone';
import { Modal } from 'react-bootstrap';
import ErrorDialog from 'components/Elements/ErrorDialog/ErrorDialog';
import ConfirmDialog from 'components/Elements/ConfirmDialog/ConfirmDialog';
import DialogStudent from 'components/Elements/DialogStudent/DialogStudent';
import TableSubjectTeachingExam from '../../../components/Elements/Table/Table-Subject-Teaching-Exam';
import DragDropInput from '../../../components/Elements/Input/Drag-drop-input/Drag-drop-input';
import { Prompt } from 'react-router';
import { _AUTH } from '../../../constants/_auth';
import fileDownload from 'js-file-download';
import auditLogService from '../../../services/audit-log.service';

function Schedule__Subject__Teaching() {
    let role = localStorage.getItem(_AUTH.ROLE) !== null && localStorage.getItem(_AUTH.ROLE) != 'Teacher' && localStorage.getItem(_AUTH.ROLE) != 'TeacherStaff';
    let history = useHistory();
    let { idSubjectTeaching } = useParams();
    const dispatch = useDispatch();
    const [errDialog, setErrDialog] = useState({ isOpen: false, subTitle: '' });
    const [isDocumentChange, setIsDocumentChange] = useState(false);
    const [modalShowSubjectSchedule, setModalShowSubjectSchedule] = useState(false);
    const [modalShowSubjectTeachingExam, setModalShowSubjectTeachingExam] = useState(false);
    const [modalShowAddNotification, setModalShowAddNotification] = useState(false);
    const [modalShowAddStudent, setModalShowAddStudent] = useState(false);
    const [noti, setNoti] = useState({ message: '', enforceRead: false });
    const [announcementType, setAnnouncementType] = useState(0); // 0: Học tập, 1: Hoạt động, 2: Dịch vụ
    const [updateSubjectSchedule, setUpdateSubjectSchedule] = useState(null);
    const [updateSubjectTeachingExam, setUpdateSubjectTeachingExam] = useState('');
    const [subjectTeachingDetail, setSubjectTeachingDetail] = useState({
        id: ''
        , name: ''
        , subjectId: ''
        , subject: []
        , startDate: new Date()
        , numberOfSubjectSchedule: 0
        , numberOfTaughtSubjectSchedule: 0
        , totalSessions: 0
        , endDate: new Date()
        , teacherId: ''
        , roomIdDefault: ''
        , teacher: []
        , note: ''
    });
    const [subjectTeachingExamList, setSubjectTeachingExamList] = useState([]);
    const [subjectScheduleTmp, setSubjectScheduleTmp] = useState({
        id: '',
        subjectTeachingId: idSubjectTeaching,
        startDate: new Date(),
        endDate: new Date(),
        startTime: '08:00',
        endTime: '11:30',
        roomId: '',
        note: '',
        isRepeatedWeekly: false
    });

    const [subjectTeachingExam, setSubjectTeachingExam] = useState({
        id: '',
        subjectTeachingId: idSubjectTeaching,
        questionSuiteId: '',
        dateExam: new Date(),
        startTime: '08:00',
        endTime: '11:30',
        name: '',
        roomIdDefault: '',
        notes: '',
        type: 1,
        count: 1,
        numOfEasy: 0,
        numOfNormal: 0,
        numOfHard: 0,
        method: null as number | null
    });


    const [timeInput, setTimeInput] = useState({
        startTime: '07:00',
        endTime: '07:00'
    });

    const [data, setData] = useState({
        id: '',
        title: '',
        start: '',
        end: '',
        backgroundColor: '#1e3a8a',
        textColor: '#1e3a8a',
        eventName: 'subject'
    });

    const [dataExam, setDataExam] = useState({
        id: '',
        title: '',
        start: '',
        end: '',
        backgroundColor: '#red',
        eventName: 'exam'
    });

    const [changes, setChanges] = useState(false);
    const [documentLists, setDocumentLists] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [questionSuite, setQuestionSuite] = useState([]);
    const [usedQuestionSuiteIds, setUsedQuestionSuiteIds] = useState<string[]>([]);
    const [originalQuestionSuiteId, setOriginalQuestionSuiteId] = useState<string>('');
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    const [examConfirmDialog, setExamConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' });
    const [confirmDialogAddNotification, setConfirmDialogAddNotification] = useState({
        isOpen: false,
        title: '',
        subTitle: ''
    });
    const [confirmCreateSubjectSchedule, setConfirmCreateSubjectSchedule] = useState({
        isOpen: false,
        title: '',
        subTitle: ''
    });
    const [confirmCreateSubjectExam, setConfirmCreateSubjectExam] = useState({
        isOpen: false,
        title: '',
        subTitle: ''
    });
    const [idDelete, setIdDelete] = useState(null);
    const [settingAttendance, setSettingAttendance] = useState(false);
    const [schedules, setSchedules] = useState([]);
    const [exams, setExams] = useState([]);
    const [showCalendar, setShowCalendar] = useState(false);
    const [logs, setLogs] = useState([]);

    function getAction(action) {
        switch (action) {
            case 1:
                return 'Thêm';
            case 2:
                return 'Cập nhật';
            case 3:
                return 'Xóa';
        }
    }

    useEffect(() => {
        // --------------------------------------------------------------------------------------------------------------------------
        async function getRooms() {
            try {
                dispatch(setLoading(true));
                const res: any = await $api.room.getAll();
                setRooms(res.result);
                dispatch(setLoading(false));
            } catch (e) {
                dispatch(setLoading(false));
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }

        async function getSubjectTeachingExam() {
            try {
                dispatch(setLoading(true));
                const res: any = await $api.exam.subjectTeachingExam_get_all(idSubjectTeaching);
                setSubjectTeachingExamList(res.result['items']);
                dispatch(setLoading(false));
            } catch (e) {
                dispatch(setLoading(false));
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }

        getSubjectTeachingExam();
        getRooms();
    }, []);

    const [subjectInfo, setSubjectInfo] = useState({});
    const [subjectDetail, setSubjectDetail] = useState({});
    const [teacherInfo, setTeacherInfo] = useState({});
    useEffect(() => {
        async function getSubjectTeachingDetail() {
            try {
                const res: any = await $api.schedule.subjectTeaching_get(idSubjectTeaching);
                setSubjectInfo(res['result']);
                setSubjectDetail(res['result'].subject);
                setTeacherInfo(res['result'].teacher);
                subjectTeachingDetail.id = res['result'].id;
                subjectTeachingDetail.name = res['result'].name;
                subjectTeachingDetail.subjectId = res['result'].subjectId;
                subjectTeachingDetail.subject = res['result'].subject;
                subjectTeachingDetail.startDate = res['result'].startDate;
                subjectTeachingDetail.endDate = res['result'].endDate;
                subjectTeachingDetail.teacherId = res['result'].teacherId;
                subjectTeachingDetail.roomIdDefault = res['result'].roomIdDefault;
                subjectTeachingDetail.teacher = res['result'].teacher;
                subjectTeachingDetail.teacher = res['result'].teacher;
                subjectTeachingDetail.note = res['result'].note;
                subjectTeachingDetail.numberOfSubjectSchedule = res['result'].numberOfSubjectSchedule;
                subjectTeachingDetail.numberOfTaughtSubjectSchedule = res['result'].numberOfTaughtSubjectSchedule;
                subjectTeachingDetail.totalSessions = res['result'].totalSessions;
                setSubjectTeachingDetail(subjectTeachingDetail);
                if (res['result']['numberOfStudent'] == 0) {
                    throw { custom_message: 'Lớp học chưa có sinh viên!' };
                }
            } catch (e) {
                dispatch(setLoading(false));
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else if (e?.custom_message) {
                    errMsg = e?.custom_message;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }

        getSubjectTeachingDetail();
    }, [changes]);
    useEffect(() => {
        // @ts-ignore
        async function getScheduleSubject(id) {
            try {
                dispatch(setLoading(true));
                const res: any = await $api.schedule.subjectSchedule_getPaging(id);
                setSchedules(res.result.items);
                const r = res.result?.items.map((item: any) => {
                    const startHour = Number.parseInt(moment(item.startDateTime + 'Z').format('HH'));
                    let backgroundColor;

                    if (startHour >= 17) {
                        // Buổi tối từ 17h: màu xanh lá
                        backgroundColor = item.isCheckAttendance ? '#16a34a' : 'rgba(22,163,74,0.5)';
                    } else if (startHour >= 12) {
                        // Buổi chiều từ 12h đến <17h: màu vàng cam
                        backgroundColor = item.isCheckAttendance ? '#f59e0b' : 'rgba(248,176,80,0.5)';
                    } else {
                        // Buổi sáng <12h: màu xanh dương
                        backgroundColor = item.isCheckAttendance ? '#1e3a8a' : 'rgba(30,58,138,0.5)';
                    }
                    return {
                        ...item,
                        title: `<b>${moment(item.startDateTime + 'Z').format(
                            'HH:mm'
                        )} - ${moment(item.endDateTime + 'Z').format(
                            'HH:mm'
                        )}</b>
						<br/><span>${item?.room?.name} ${item.isCheckAttendance ? '- Đã điểm danh' : ''}</span>`,
                        start: moment(item.startDateTime + 'Z').format('YYYY-MM-DD'),
                        end: moment(item.endDateTime + 'Z').format('YYYY-MM-DD'),
                        backgroundColor: backgroundColor,
                        eventName: 'subject'
                    };
                });
                // @ts-ignore
                setData(r);
                dispatch(setLoading(false));
            } catch (e) {
                dispatch(setLoading(false));
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }

        async function getSubjectTeachingExam(id) {
            try {
                dispatch(setLoading(true));
                const res: any = await $api.exam.subjectTeachingExam_get_all(id);
                setExams(res.result.items);
                const r = res.result?.items.map((item: any) => {
                    return {
                        ...item,
                        title: `<b>${moment(item.startDate + 'Z').format(
                            'HH:mm'
                        )} - ${moment(item.endDate + 'Z').format(
                            'HH:mm'
                        )}</b>
						<br/><b>${(item?.type == 3 ? 'Thi: ' : 'Kiểm tra: ') + item?.name}</b>`,
                        start: moment(item.startDate + 'Z').format('YYYY-MM-DD'),
                        end: moment(item.endDate + 'Z').format('YYYY-MM-DD'),
                        backgroundColor: '#c42828',
                        eventName: 'exam'
                    };
                });
                setDataExam(r);
                setSubjectTeachingExamList(res.result['items']);
                dispatch(setLoading(false));
            } catch (e) {
                dispatch(setLoading(false));
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }

        async function getLog(id) {
            try
            {
                const res: any = await auditLogService.getPaging({
                    recordId: id
                });
                setLogs(res.result.items);
            }
            catch (e) {
                dispatch(setLoading(false));
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }

        if (idSubjectTeaching && idSubjectTeaching?.length) {
            getScheduleSubject(idSubjectTeaching);
            getSubjectTeachingExam(idSubjectTeaching);
            getLog(idSubjectTeaching);
        }
    }, [changes]);
    useEffect(() => {
        getQuestionSuite();
    }, [subjectDetail, changes]);

    useEffect(() => {
        async function getDocument() {
            try {
                const res: any = await $api.subjectDocument.getPagingDocument({
                    subjectId: subjectDetail['id']
                });
                setDocumentLists(() => res['result']['items']);
                setIsDocumentChange(() => false);
            } catch (e) {
                dispatch(setLoading(false));
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }

        getDocument();
    }, [subjectDetail, isDocumentChange]);
    useEffect(() => {
        async function getSetting() {
            try {
                dispatch(setLoading(true));
                const res: any = await $api.setting.getSettingAttendance();
                if (res && res.result) {
                    setSettingAttendance(() => Boolean(res.result.value));
                }
                dispatch(setLoading(false));
            } catch (e) {
                dispatch(setLoading(false));
                // show_ErrMsg(e?.response?.data?.errors?.exceptionMessage ? e?.response?.data?.errors?.exceptionMessage.title : 'Đã có lỗi xảy ra, xin vui lòng thử lại');
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }

        getSetting();
    }, []);

    async function getQuestionSuite() {
        try {
            dispatch(setLoading(true));
            const res: any = await $api.question.getQuestionSuite(subjectDetail['id'], '');
            setQuestionSuite(res.result.items);
            dispatch(setLoading(false));
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function isEventClicked(eventId, eventName) {
        try {
            if (eventName === 'exam') {
                if (!role) return;
                dispatch(setLoading(true));
                const res: any = await $api.exam.subjectTeachingExam_get(eventId);
                const startTime = moment(res.result.startDate + 'Z').format('HH:mm');
                const endTime = moment(res.result.endDate + 'Z').format('HH:mm');
                setSubjectTeachingExam({
                    endTime: moment(res.result.endDate + 'Z').format('HH:mm'),
                    startTime: moment(res.result.startDate + 'Z').format('HH:mm'),
                    subjectTeachingId: res.result.subjectTeachingId,
                    id: res.result.id,
                    dateExam: res.result.startDate,
                    name: res.result.name,
                    notes: res.result.notes,
                    type: res.result.type,
                    count: res.result.count,
                    roomIdDefault: res.result.roomIdDefault,
                    questionSuiteId: res.result.questionSuiteId,
                    numOfEasy: res.result.numOfEasy,
                    numOfNormal: res.result.numOfNormal,
                    numOfHard: res.result.numOfHard,
                    method: res.result.method
                });
                setTimeInput({
                    startTime: startTime,
                    endTime: endTime
                });
                setModalShowSubjectTeachingExam(true);
                setUpdateSubjectTeachingExam(eventId);
                setChanges(!changes);
                dispatch(setLoading(false));
            } else {
                dispatch(setLoading(true));
                const res: any = await $api.schedule.subjectSchedule_get(eventId);
                const startTime = moment(res.result.startDateTime + 'Z').format('HH:mm');
                const endTime = moment(res.result.endDateTime + 'Z').format('HH:mm');
                setSubjectScheduleTmp({
                    id: eventId,
                    subjectTeachingId: res.result.subjectTeachingId,
                    startDate: new Date(res.result.startDateTime + 'Z'),
                    endDate: new Date(res.result.startDateTime + 'Z'),
                    startTime: startTime,
                    endTime: endTime,
                    roomId: res.result.roomId,
                    isRepeatedWeekly: false,
                    note: res.result.note
                });
                setTimeInput({
                    startTime: startTime,
                    endTime: endTime
                });
                setModalShowSubjectSchedule(true);
                setUpdateSubjectSchedule(eventId);
                setChanges(!changes);
                dispatch(setLoading(false));
            }
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    function setDatWithTime(date, time) {
        const hour = time.split(':')[0] || 9;
        const min = time.split(':')[1] || 0;
        if ((Number.parseInt(time) - 7) >= 10) {
            return moment(date).format('YYYY-MM-DD') + 'T' + (Number(hour) - 7) + ':' + min + ':00.000Z';
        } else {
            return moment(date).format('YYYY-MM-DD') + 'T' + '0' + (Number(hour) - 7) + ':' + min + ':00.000Z';
        }
    }

    function show_ErrMsg(msg) {
        setErrDialog({
            isOpen: true
            , subTitle: msg
        });
    }

    async function isCreateSubjectSchdule() {
        setConfirmCreateSubjectSchedule({
            isOpen: false,
            title: '',
            subTitle: ''
        });
        try {
            subjectScheduleTmp.id = '';
            subjectScheduleTmp.subjectTeachingId = subjectTeachingDetail.id;
            subjectScheduleTmp.startDate = new Date();
            subjectScheduleTmp.endDate = new Date();
            subjectScheduleTmp.startTime = '08:00';
            subjectScheduleTmp.endTime = '11:30';
            subjectScheduleTmp.roomId = subjectTeachingDetail.roomIdDefault;
            subjectScheduleTmp.note = subjectTeachingDetail.note;
            setSubjectScheduleTmp(subjectScheduleTmp);
            setTimeInput({
                startTime: '08:00',
                endTime: '11:30'
            });
            setUpdateSubjectSchedule(null);
            setModalShowSubjectSchedule(true);
        } catch (e) {
        }
    }

    async function isCreateSubjectTeachingExam() {
        setConfirmCreateSubjectExam({
            isOpen: false,
            title: '',
            subTitle: ''
        });
        try {
            subjectTeachingExam.id = '';
            subjectTeachingExam.subjectTeachingId = subjectTeachingDetail.id;
            subjectTeachingExam.dateExam = new Date();
            subjectTeachingExam.startTime = '08:00';
            subjectTeachingExam.endTime = '11:30';
            subjectTeachingExam.notes = '';
            subjectTeachingExam.type = 1;
            subjectTeachingExam.count = 1;
            subjectTeachingExam.roomIdDefault = subjectTeachingDetail.roomIdDefault;
            subjectTeachingExam.method = null;
            setSubjectTeachingExam(subjectTeachingExam);
            setOriginalQuestionSuiteId('');
            setTimeInput({
                startTime: '08:00',
                endTime: '11:30'
            });
            setUpdateSubjectTeachingExam('');
            setModalShowSubjectTeachingExam(true);
        } catch (e) {
        }
    }

    async function onSaveSubjectSchedule() {
        if (!subjectScheduleTmp.isRepeatedWeekly) {
            if (setDatWithTime(subjectScheduleTmp.startDate, timeInput.endTime) <= setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime)) {
                show_ErrMsg('Thời gian buổi học không hợp lệ. Vui lòng kiểm tra lại');
                return;
            }
        } else {
            if (setDatWithTime(subjectScheduleTmp.endDate, timeInput.endTime) <= setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime)) {
                show_ErrMsg('Thời gian buổi học không hợp lệ. Vui lòng kiểm tra lại');
                return;
            }
        }

        try {
            // dispatch(setLoading(true));
            if (!updateSubjectSchedule) {
                const postData = {
                    subjectTeachingId: subjectScheduleTmp.subjectTeachingId,
                    startDateTime: setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime),
                    endDateTime: setDatWithTime(subjectScheduleTmp.isRepeatedWeekly ? subjectScheduleTmp.endDate : subjectScheduleTmp.startDate, timeInput.endTime),
                    roomId: subjectScheduleTmp.roomId,
                    note: subjectScheduleTmp.note
                };

                if (subjectScheduleTmp.isRepeatedWeekly) {
                    const res: any = await $api.schedule.subjectSchedule_createRepeat(postData);
                    dispatch(
                        setAlert({
                            title: res.message
                        })
                    );
                } else {
                    const res: any = await $api.schedule.subjectSchedule_create([postData]);
                    dispatch(
                        setAlert({
                            title: res.message
                        })
                    );
                }
            } else {
                const postData = {
                    id: subjectScheduleTmp.id,
                    startDateTime: setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime),
                    endDateTime: setDatWithTime(subjectScheduleTmp.isRepeatedWeekly ? subjectScheduleTmp.endDate : subjectScheduleTmp.startDate, timeInput.endTime),
                    roomId: subjectScheduleTmp.roomId,
                    note: subjectScheduleTmp.note
                };
                const res: any = await $api.schedule.subjectSchedule_Update(postData);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            }
            setSubjectScheduleTmp({
                id: '',
                subjectTeachingId: idSubjectTeaching,
                startDate: new Date(),
                endDate: new Date(),
                startTime: '08:00',
                endTime: '11:30',
                roomId: subjectTeachingDetail.roomIdDefault,
                isRepeatedWeekly: false,
                note: ''
            });
            setTimeInput({
                startTime: '08:00',
                endTime: '11:30'
            });
            setModalShowSubjectSchedule(false);
            setChanges(!changes);
            dispatch(setLoading(false));

        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function onSaveSubjectTeachingExam() {
        if (subjectTeachingExam.name === '') {
            show_ErrMsg('Nhập tên lịch thi');
            return;
        }
        if (!(subjectTeachingExam.count > 0 && subjectTeachingExam.count <= 4)) {
            show_ErrMsg('Lần thi không hợp lệ. Nhỏ nhất 1 và lớn nhất 4');
            return;
        }
        const isQuestionSuiteChanged = (subjectTeachingExam.questionSuiteId || '') !== (originalQuestionSuiteId || '');
        if (isQuestionSuiteChanged && subjectTeachingExam.questionSuiteId && usedQuestionSuiteIds.includes(subjectTeachingExam.questionSuiteId)) {
            const examName = getExamUsingQuestionSuite(subjectTeachingExam.questionSuiteId);
            show_ErrMsg(`Bộ đề thi này đã được sử dụng trong kỳ thi: ${examName}`);
            return;
        }
        if (setDatWithTime(subjectTeachingExam.dateExam, timeInput.endTime) <= setDatWithTime(subjectTeachingExam.dateExam, timeInput.startTime)) {
            show_ErrMsg('Thời gian buổi thi không hợp lệ. Vui lòng kiểm tra lại');
            return;
        }


        try {
            // dispatch(setLoading(true));
            if (!updateSubjectTeachingExam) {
                const postData = {
                    'subjectTeachingId': subjectTeachingExam.subjectTeachingId,
                    'name': subjectTeachingExam.name,
                    'type': subjectTeachingExam.type,
                    'count': subjectTeachingExam.count,
                    'startDate': setDatWithTime(subjectTeachingExam.dateExam, timeInput.startTime),
                    'endDate': setDatWithTime(subjectTeachingExam.dateExam, timeInput.endTime),
                    'roomIdDefault': subjectTeachingExam.roomIdDefault,
                    'questionSuiteId': subjectTeachingExam.questionSuiteId,
                    'numOfEasy': subjectTeachingExam.numOfEasy,
                    'numOfNormal': subjectTeachingExam.numOfNormal,
                    'numOfHard': subjectTeachingExam.numOfHard,
                    'notes': subjectTeachingExam.notes,
                    'method': subjectTeachingExam.method
                };
                const res: any = await $api.exam.subjectTeachingExam_save(postData);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            } else {
                const postData = {
                    'id': subjectTeachingExam.id,
                    'subjectTeachingId': subjectTeachingExam.subjectTeachingId,
                    'name': subjectTeachingExam.name,
                    'type': subjectTeachingExam.type,
                    'count': subjectTeachingExam.count,
                    'startDate': setDatWithTime(subjectTeachingExam.dateExam, timeInput.startTime),
                    'endDate': setDatWithTime(subjectTeachingExam.dateExam, timeInput.endTime),
                    'roomIdDefault': subjectTeachingExam.roomIdDefault,
                    'questionSuiteId': subjectTeachingExam.questionSuiteId,
                    'numOfEasy': subjectTeachingExam.numOfEasy,
                    'numOfNormal': subjectTeachingExam.numOfNormal,
                    'numOfHard': subjectTeachingExam.numOfHard,
                    'notes': subjectTeachingExam.notes,
                    'method': subjectTeachingExam.method
                };
                const res: any = await $api.exam.subjectTeachingExam_save(postData);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            }
            setSubjectTeachingExam({
                id: '',
                subjectTeachingId: idSubjectTeaching,
                dateExam: new Date(),
                startTime: '08:00',
                endTime: '11:30',
                name: '',
                type: 1,
                count: 1,
                notes: '',
                roomIdDefault: subjectTeachingDetail.roomIdDefault,
                questionSuiteId: '',
                numOfEasy: 0,
                numOfNormal: 0,
                numOfHard: 0,
                method: null
            });
            setTimeInput({
                startTime: '08:00',
                endTime: '11:30'
            });
            setModalShowSubjectTeachingExam(false);
            setChanges(!changes);
            dispatch(setLoading(false));

        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function onSaveContinueSubjectSchedule() {
        if (!subjectScheduleTmp.isRepeatedWeekly) {
            if (setDatWithTime(subjectScheduleTmp.startDate, timeInput.endTime) <= setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime)) {
                show_ErrMsg('Thời gian buổi học không hợp lệ. Vui lòng kiểm tra lại');
                return;
            }
        } else {
            if (setDatWithTime(subjectScheduleTmp.endDate, timeInput.endTime) <= setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime)) {
                show_ErrMsg('Thời gian buổi học không hợp lệ. Vui lòng kiểm tra lại');
                return;
            }
        }
        try {
            // dispatch(setLoading(true));
            const postData = {
                subjectTeachingId: subjectScheduleTmp.subjectTeachingId,
                startDateTime: setDatWithTime(subjectScheduleTmp.startDate, timeInput.startTime),
                endDateTime: setDatWithTime(subjectScheduleTmp.isRepeatedWeekly ? subjectScheduleTmp.endDate : subjectScheduleTmp.startDate, timeInput.endTime),
                roomId: subjectScheduleTmp.roomId
            };
            if (subjectScheduleTmp.isRepeatedWeekly) {
                const res: any = await $api.schedule.subjectSchedule_createRepeat(postData);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            } else {
                const res: any = await $api.schedule.subjectSchedule_create([postData]);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            }
            setSubjectTeachingDetail({
                ...subjectTeachingDetail,
                numberOfSubjectSchedule: subjectTeachingDetail.numberOfSubjectSchedule++
            });
            setSubjectScheduleTmp({
                ...subjectScheduleTmp,
                id: '',
                subjectTeachingId: idSubjectTeaching,
                // startDate: subjectTeachingDetail.startDate,
                // endDate: subjectTeachingDetail.startDate,
                startTime: '08:00',
                endTime: '11:30',
                // roomId: subjectTeachingDetail.roomIdDefault
                // isRepeatedWeekly: false
            });
            setTimeInput({
                startTime: '08:00',
                endTime: '11:30'
            });

            setChanges(!changes);
            dispatch(setLoading(false));
            createSubjectScheduleAction();
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function onSaveContinueSubjectTeachingExam() {

        if (subjectTeachingExam.name === '') {
            show_ErrMsg('Nhập tên lịch thi');
            return;
        }
        if (!(subjectTeachingExam.count > 0 && subjectTeachingExam.count <= 4)) {
            show_ErrMsg('Lần thi không hợp lệ. Nhỏ nhất 1 và lớn nhất 4');
            return;
        }
        const isQuestionSuiteChanged = (subjectTeachingExam.questionSuiteId || '') !== (originalQuestionSuiteId || '');
        if (isQuestionSuiteChanged && subjectTeachingExam.questionSuiteId && usedQuestionSuiteIds.includes(subjectTeachingExam.questionSuiteId)) {
            const examName = getExamUsingQuestionSuite(subjectTeachingExam.questionSuiteId);
            show_ErrMsg(`Bộ đề thi này đã được sử dụng trong kỳ thi: ${examName}`);
            return;
        }
        if (setDatWithTime(subjectTeachingExam.dateExam, timeInput.endTime) <= setDatWithTime(subjectTeachingExam.dateExam, timeInput.startTime)) {
            show_ErrMsg('Thời gian buổi thi không hợp lệ. Vui lòng kiểm tra lại');
            return;
        }

        try {
            // dispatch(setLoading(true));
            if (!updateSubjectTeachingExam) {
                const postData = {
                    'subjectTeachingId': subjectTeachingExam.subjectTeachingId,
                    'name': subjectTeachingExam.name,
                    'type': subjectTeachingExam.type,
                    'count': subjectTeachingExam.count,
                    'startDate': setDatWithTime(subjectTeachingExam.dateExam, timeInput.startTime),
                    'endDate': setDatWithTime(subjectTeachingExam.dateExam, timeInput.endTime),
                    'roomIdDefault': subjectTeachingExam.roomIdDefault,
                    'questionSuiteId': subjectTeachingExam.questionSuiteId,
                    'numOfEasy': subjectTeachingExam.numOfEasy,
                    'numOfNormal': subjectTeachingExam.numOfNormal,
                    'numOfHard': subjectTeachingExam.numOfHard,
                    'notes': subjectTeachingExam.notes,
                    'method': subjectTeachingExam.method
                };
                const res: any = await $api.exam.subjectTeachingExam_save(postData);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            } else {
                const postData = {
                    'id': subjectTeachingExam.id,
                    'subjectTeachingId': subjectTeachingExam.subjectTeachingId,
                    'name': subjectTeachingExam.name,
                    'type': subjectTeachingExam.type,
                    'count': subjectTeachingExam.count,
                    'startDate': setDatWithTime(subjectTeachingExam.dateExam, timeInput.startTime),
                    'endDate': setDatWithTime(subjectTeachingExam.dateExam, timeInput.endTime),
                    'roomIdDefault': subjectTeachingExam.roomIdDefault,
                    'questionSuiteId': subjectTeachingExam.questionSuiteId,
                    'numOfEasy': subjectTeachingExam.numOfEasy,
                    'numOfNormal': subjectTeachingExam.numOfNormal,
                    'numOfHard': subjectTeachingExam.numOfHard,
                    'notes': subjectTeachingExam.notes,
                    'method': subjectTeachingExam.method
                };
                const res: any = await $api.exam.subjectTeachingExam_save(postData);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            }
            setSubjectTeachingDetail({
                ...subjectTeachingDetail,
                numberOfSubjectSchedule: subjectTeachingDetail.numberOfSubjectSchedule++
            });
            setSubjectTeachingExam({
                id: '',
                subjectTeachingId: idSubjectTeaching,
                dateExam: new Date(),
                startTime: '08:00',
                endTime: '11:30',
                name: '',
                type: 1,
                count: 1,
                notes: '',
                roomIdDefault: subjectTeachingDetail.roomIdDefault,
                questionSuiteId: '',
                numOfEasy: 0,
                numOfNormal: 0,
                numOfHard: 0,
                method: null
            });
            setTimeInput({
                startTime: '08:00',
                endTime: '11:30'
            });
            setChanges(!changes);
            dispatch(setLoading(false));
            createSubjectExamAction();
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function isDeleteSubjectSchedule() {
        setConfirmDialog({
            isOpen: true
            , title: 'Thông báo'
            , subTitle: 'Bạn có chắc muốn xóa ?'
        });
        // @ts-ignore
        setIdDelete(subjectScheduleTmp.id);
    }

    async function isDeleteSubjectTeachingExam(id) {
        setExamConfirmDialog({
            isOpen: true
            , title: 'Thông báo'
            , subTitle: 'Bạn có chắc muốn xóa ?'
        });
        // @ts-ignore
        setIdDelete(id);
    }

    async function addNotificationSubject() {
        setConfirmDialogAddNotification({ isOpen: false, title: '', subTitle: '' });
        try {
            dispatch(setLoading(true));
            const res: any = await $api.schedule.subjectTeaching_createNotification({
                'subjectTeachingId': subjectScheduleTmp.subjectTeachingId,
                'message': noti.message,
                'enforceRead': noti.enforceRead,
                'notificationType': announcementType
            });
            if (res) {
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
                setModalShowAddNotification(false);
                setNoti({ message: '', enforceRead: false });
                setAnnouncementType(0);
                setModalShowSubjectSchedule(false);
                setUpdateSubjectSchedule(null);
                setChanges(!changes);
                dispatch(setLoading(false));
            }
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function deleteItem() {
        setConfirmDialog({ isOpen: false, title: '', subTitle: '' });
        try {
            dispatch(setLoading(true));
            const res: any = await $api.schedule.subjectSchedule_Delete(idDelete);
            if (res) {
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
                setModalShowSubjectSchedule(false);
                setUpdateSubjectSchedule(null);
                setChanges(!changes);
                dispatch(setLoading(false));
            }
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function deleteExamItem() {
        setExamConfirmDialog({ isOpen: false, title: '', subTitle: '' });
        try {
            dispatch(setLoading(true));
            const res: any = await $api.exam.subjectTeachingExam_delete(idDelete);
            if (res) {
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
                setModalShowSubjectTeachingExam(false);
                setUpdateSubjectTeachingExam('');
                setChanges(!changes);
                dispatch(setLoading(false));
            }
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function isRepeatedWeekly_Checked(e) {
        setSubjectScheduleTmp({
            ...subjectScheduleTmp,
            isRepeatedWeekly: e.target.checked
        });
    }

    async function isAddStudentToSubjectSchedule(e) {
        e.stopPropagation();
        try {
            setModalShowAddStudent(true);
        } catch (e) {
        }
    }

    async function createNotification() {
        if (noti.message.length) {
            // @ts-ignore
            setConfirmDialogAddNotification({
                isOpen: true,
                title: 'Xác nhận',
                subTitle: 'Bạn muốn gửi thông báo: "' + noti.message + '" Cho môn ' + `${subjectInfo['name']}` + '?'
            });
        } else {
            setErrDialog({
                isOpen: true,
                subTitle: 'Bạn chưa nhập nội dung thông báo!'
            });
        }
    }

    async function openUpdateExam(e, exam) {
        e.stopPropagation();
        try {
            setOriginalQuestionSuiteId(exam.questionSuiteId || '');
            setSubjectTeachingExam({
                id: exam.id,
                subjectTeachingId: exam.subjectTeachingId,
                dateExam: new Date(exam.startDate),
                endTime: moment(exam.endDate).format('HH:mm'),
                startTime: moment(exam.startDate).format('HH:mm'),
                name: exam.name,
                notes: exam.notes,
                type: exam.type,
                count: exam.count,
                roomIdDefault: exam.roomIdDefault,
                questionSuiteId: exam.questionSuiteId,
                numOfEasy: exam.numOfEasy,
                numOfNormal: exam.numOfNormal,
                numOfHard: exam.numOfHard,
                method: exam.method
            });
            setTimeInput({
                endTime: moment(exam.endDate + 'Z').format('HH:mm'),
                startTime: moment(exam.startDate + 'Z').format('HH:mm')
            });
            setUpdateSubjectTeachingExam('update');
            setModalShowSubjectTeachingExam(true);
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    function goAttendanceExam(subjectTeachingExam) {
        console.log(subjectTeachingExam)
        if (settingAttendance) {
            history.push('/diem-danh-lich-thi?id=' + subjectTeachingExam.id + '&subjectTeachingId=' + subjectTeachingExam.subjectTeachingId);
        } else {
            isCurrentAttendanceTimeInRange(subjectTeachingExam);
        }
    }
    function goAttendance(subjectSchedule) {
        console.log(subjectSchedule)
        if (settingAttendance) {
            history.push('/diem-danh?id=' + subjectSchedule.id);
        } else {
            isCurrentAttendanceTimeInRange(subjectSchedule);

        }
    }

    //XỬ lý thời gian hiện tại có nằm trong khoảng giời buổi học
    function isCurrentAttendanceTimeInRange(subjectSchedule) {
        const date = moment(subjectSchedule.startDate).format('YYYY-MM-DD');
        const startTime = moment(subjectSchedule.startTime, 'HH:mm').format('HH:mm');
        const endTime = moment(subjectSchedule.endTime, 'HH:mm').format('HH:mm');

        const startDateTime = moment(`${date} ${startTime}`, 'YYYY-MM-DD HH:mm');
        const endDateTime = moment(`${date} ${endTime}`, 'YYYY-MM-DD HH:mm');

        const currentTime = moment();
        if (currentTime.isBefore(startDateTime)) {
            show_ErrMsg('Buổi học chưa đến thời gian điểm danh!');
        } else if (currentTime.isAfter(endDateTime)) {
            show_ErrMsg('Buổi học đã qua thời gian điểm danh!');
        } else {
            history.push('/diem-danh?id=' + subjectSchedule.id);
        }
    }

    function customPromptMessage() {
        show_ErrMsg('Lớp học chưa có sinh viên!');
        return false;
    }

    async function examBySubjectTeachingProcess() {
        const res: any = await $api.exam.examBySubjectTeachingProcess(idSubjectTeaching);
        fileDownload(res, `Bang-diem-qua-trinh-mon-hoc-${subjectDetail['name']}-ngay-xuat-ket-qua-${moment((new Date())).format('DD/MM/YYYY')}.xlsx`);
    }

    async function examExportSubjectStudent() {
        const res: any = await $api.schedule.subjectStudent_Export(idSubjectTeaching);
        fileDownload(res, `Danh-sach-du-thi-mon-hoc-${subjectDetail['name']}-ngay-xuat-ket-qua-${moment((new Date())).format('DD/MM/YYYY')}.xlsx`);
    }

    async function importSubjectScheduleAction() {
        // @ts-ignore
        document.getElementById('subject-schedule-import').click();
    }

    async function importSubjectSchedule(event) {
        const formData = new FormData();
        formData.append('formFile', event.target.files[0]);
        try {
            dispatch(setLoading(true));
            const res: any = await $api.schedule.subjectSchedulesImport(
                formData
            );
            if (res && res.message) {
                setChanges(!changes);
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
                dispatch(setLoading(false));
                return;
            }
            if (res && res.errors) {
                dispatch(setLoading(false));
                show_ErrMsg(res?.errors?.exceptionMessage ? res?.errors?.exceptionMessage.title : 'Đã có lỗi xảy ra, xin vui lòng thử lại');
                return;
            }
        } catch (e) {
            let err = '';
            if (e.response && e.response.data && e.response.data.errors) {
                err += e.response.data.errors['success'].detail;
                if (e.response.data.errors.rowErrors) {
                    err += '\r\n';
                    err += '-------------------------------------------------------';
                    err += '\r\n';
                    for (var er of e.response.data.errors.rowErrors['details']) {
                        err += er + '\r\n';
                    }
                } else {
                    err = e.response.data.errors.exceptionMessage;
                }
            }
            if (e.response.data.errors['success'].count !== 0) {
                setChanges(!changes);
            }
            dispatch(setLoading(false));
            show_ErrMsg(err);
            return;
        } finally {
            event.target.value = '';
        }
    }

    function createSubjectScheduleAction() {
        setModalShowSubjectSchedule(false);
        let totalToEnd = subjectTeachingDetail.totalSessions - subjectTeachingDetail.numberOfSubjectSchedule;
        if (totalToEnd <= 2) {
            setConfirmCreateSubjectSchedule({
                isOpen: true,
                title: 'Xác nhận',
                subTitle: totalToEnd > 0 ? 'Lịch học còn lại ' + totalToEnd + ' buổi, muốn tiếp tục tạo lịch học?' : 'Số buổi học vượt quá số buổi dự kiến muốn tiếp tục tạo lịch học?'
            });
        } else {
            isCreateSubjectSchdule();
        }
    }

    function createSubjectExamAction() {
        setModalShowSubjectTeachingExam(false);
        let totalToEnd = subjectTeachingDetail.totalSessions - subjectTeachingDetail.numberOfSubjectSchedule;
        if (totalToEnd <= 2) {
            setConfirmCreateSubjectExam({
                isOpen: true,
                title: 'Xác nhận',
                subTitle: totalToEnd > 0 ? 'Số buổi còn lại ' + totalToEnd + ' muốn, tiếp tục tạo lịch thi?' : 'Số buổi hiện đã vượt quá số buổi dự kiến muốn tiếp tục tạo lịch thi?'
            });
        } else {
            isCreateSubjectTeachingExam();
        }
    }

    function gotoViewResultExam(e: any, item: any) {
        history.push(`/chi-tiet-lich-thi/${item.id}`);
    }

    function getTypeExam(typeExam) {
        switch (typeExam) {
            case  1:
                return 'Thường xuyên';
            case 2:
                return 'Giữa kỳ';
            case 3:
                return 'Cuối kỳ';
            case 4:
                return 'Tổng kết'
            default:
                return '';
        }
    }

    // Track used question suite IDs from all exams (excluding the current exam being edited)
    useEffect(() => {
        const usedIds = subjectTeachingExamList
            .filter((exam: any) => exam.id !== subjectTeachingExam.id && !!exam.questionSuiteId)
            .map((exam: any) => exam.questionSuiteId as string);
        setUsedQuestionSuiteIds(usedIds);
    }, [subjectTeachingExamList, subjectTeachingExam.id]);

    function getExamUsingQuestionSuite(questionSuiteId: string) {
        const exam: any = subjectTeachingExamList.find(
            (e: any) => e.id !== subjectTeachingExam.id && e.questionSuiteId === questionSuiteId
        );
        return exam ? exam.name : '';
    }

    return (
        <DefaultLayout>
            <input
                type='file'
                id='subject-schedule-import'
                className='hidden'
                accept='.xlsx, .xls, .csv'
                onChange={(e) => {
                    importSubjectSchedule(e);
                }}
            />
            <div className='faculties page'>
                <div className='page__header'>
                    <Prompt
                        when={subjectInfo['numberOfStudent'] == 0}
                        message={customPromptMessage}
                        // message={'Lớp học chưa có sinh viên!'}
                    />
                    <div className='___title flex items-center'>
                        <div className='___title__decorate' />
                        <Link to={`/thoi-khoa-bieu`}>Danh sách môn học</Link>
                        <div className='___title__box__last'>{`>`}</div>
                        <div>
                            {
                                // @ts-ignore
                                // <a href={`/lich-hoc-mon?id=${subjectTeachingDetail['subject']?.id}`}>
                                // 	{
                                // 		// @ts-ignore
                                // 		subjectTeachingDetail['subject']?.name
                                // 	}
                                // </a>

                                // NhutTrung
                                <Link to={`/lich-hoc-mon?id=${subjectDetail['id']}`}>
                                    {

                                        subjectDetail['name']
                                    }
                                </Link>

                            }
                        </div>
                        <div className='___title__box__last'>{`>`}</div>
                        <div>
                            {
                                // @ts-ignore
                                // subjectTeachingDetail?.name

                                // NhutTrung
                                subjectInfo['name']
                            }
                        </div>
                    </div>
                </div>
                <div className='page__content bg-white mt-3'>
                    <div>
                        <div className='flex justify-between items-end flex-wrap'>
                            <div className='action--item flex justify-between items-end w-full'>
                                {role ? <>
                                    <div className={'flex flex-row'}>
                                        <div
                                            className='actions--item mr-1'
                                            onClick={(e) => {
                                                createSubjectScheduleAction();
                                            }}>
                                            <Button
                                                label='Tạo thời khóa biểu'
                                                icon={<i className='fas fa-calendar-plus' />}
                                            />
                                        </div>
                                        <div
                                            className='actions--item'
                                            onClick={importSubjectScheduleAction}>
                                            <Button
                                                label='Nhập thời khóa biểu'
                                                icon={<i className='fas fa-download' />}
                                                color='bg-green-700'
                                                hoverColor='bg-green-800'
                                            />
                                        </div>
                                    </div>
                                    <div className={'flex flex-row'}>
                                        <div
                                            className='actions--item'
                                            onClick={(e) => {
                                                createSubjectExamAction();
                                            }}>
                                            <Button
                                                label='Tạo lịch thi'
                                                icon={<i className='fas fa-calendar-plus' />}
                                            />
                                        </div>
                                        <div
                                            className='actions--item mx-1'
                                            onClick={(e) => {
                                                isAddStudentToSubjectSchedule(e);
                                            }}>
                                            <Button
                                                label='Thêm Sinh viên'
                                                icon={<i className='fas fa-user-plus' />}
                                            />
                                        </div>
                                        <div className='actions--item'
                                             onClick={() => setModalShowAddNotification(true)}>
                                            <Button
                                                color={'bg-green-800'}
                                                hoverColor={'bg-green-900'}
                                                label='Thông báo môn học'
                                                icon={<i className='far fa-bell' />}
                                            />
                                        </div>
                                    </div>
                                </> : <div className='actions--item' onClick={() => setModalShowAddNotification(true)}>
                                    <Button
                                        color={'bg-green-800'}
                                        hoverColor={'bg-green-900'}
                                        label='Thông báo môn học'
                                        icon={<i className='far fa-bell' />}
                                    />
                                </div>}
                            </div>
                        </div>
                    </div>
                    <div className='p-layout mt-8'>
                        <div className='tab-content'>
                            <Tabs defaultIndex={0}>
                                <TabList>
                                    <Tab>Lịch học</Tab>
                                    <Tab>Thông tin lịch học</Tab>
                                    <Tab>Lịch thi</Tab>
                                    <Tab>Tài liệu</Tab>
                                    <Tab>Nhật ký</Tab>
                                </TabList>
                                <TabPanel>
                                    <div className="mt-4 mb-4">
                                        <div className='mb-3 text-green-700 hover:text-blue-800 font-semibold cursor-pointer'>
                                            <a href={`/chi-tiet-lop-mon-hoc/` + idSubjectTeaching}>
                                                <i className='far fa-eye mr-2' />
                                                Xem chi tiết lớp môn học
                                            </a>
                                        </div>
                                        <h2 className="text-lg font-semibold mb-2">Danh sách lịch học</h2>
                                        <div className="overflow-x-auto">
                                            <table className="min-w-full divide-y divide-gray-200">
                                                <thead className='bg-gray-50'>
                                                <tr>
                                                    <th className="p-3 text-xs font-medium text-gray-500 uppercase tracking-wider">STT</th>
                                                    <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ngày</th>
                                                    <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Thời gian</th>
                                                    <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phòng</th>
                                                    <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Trạng thái</th>
                                                    <th className="p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ghi chú</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {schedules.map((item : any, index) => {
                                                    // Determine background color based on startDateTime
                                                    const startHour = moment(item.startDateTime + 'Z').hour();
                                                    let bgColor = 'bg-blue-50'; // Default: morning

                                                    if (startHour >= 12 && startHour < 17) {
                                                        bgColor = 'bg-yellow-50'; // Afternoon: 12h to <17h
                                                    } else if (startHour >= 17) {
                                                        bgColor = 'bg-green-200'; // Evening: from 17h
                                                    }

                                                    return (
                                                        <tr
                                                            key={item.id}
                                                            className={`hover:bg-gray-100 cursor-pointer ${bgColor}`}
                                                            onClick={() => isEventClicked(item.id, item.eventName)}
                                                        >
                                                            <td className="p-3 border-b text-center">
                                                                {index + 1}
                                                            </td>
                                                            <td className="p-3 border-b text-left">
                                                                {moment(item.startDateTime).format('DD/MM/YYYY')}
                                                            </td>
                                                            <td className="p-3 border-b text-left">
                                                                {moment(item.startDateTime + 'Z').format('HH:mm')} - {moment(item.endDateTime + 'Z').format('HH:mm')}
                                                            </td>
                                                            <td className="p-3 border-b text-left">
                                                                {item.roomName || '-'}
                                                            </td>
                                                            <td className="p-3 border-b text-left">
                                                                {item.isCheckAttendance ? (
                                                                    <span className="bg-green-100 text-green-800 px-2 py-1 rounded">Đã điểm danh</span>
                                                                ) : (
                                                                    <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded">Chưa điểm danh</span>
                                                                )}
                                                            </td>
                                                            <td className="p-3 border-b text-left">
                                                                {item.note || ''}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                                {exams.length >0 && exams.map((exam : any, index) => (
                                                    <tr 
                                                        key={exam.id}
                                                        className="bg-red-300 hover:bg-gray-100 cursor-pointer"
                                                        onClick={() => isEventClicked(exam.id, 'exam')}
                                                    >
                                                        <td className="p-3 border-b text-center">
                                                            {schedules.length + index + 1}
                                                        </td>
                                                        <td className="p-3 border-b text-left">
                                                            {moment(exam.startDate).format('DD/MM/YYYY')}
                                                        </td>
                                                        <td className="p-3 border-b text-left">
                                                            {moment(exam.startDate + 'Z').format('HH:mm')} - {moment(exam.endDate + 'Z').format('HH:mm')}
                                                        </td>
                                                        <td className="p-3 border-b text-left">
                                                            {exam.roomName || '-'}
                                                        </td>
                                                        <td className="p-3 border-b text-left">
                                                            <span className="bg-green-100 text-green-800 px-2 py-1 rounded">{getTypeExam(exam.type)}{exam.count > 1 ? ` - lần ${exam.count}` : ''}</span>
                                                        </td>
                                                        <td className="p-3 border-b text-left">
                                                            {exam.notes || ''}
                                                        </td>
                                                    </tr>
                                                ))}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => setShowCalendar(!showCalendar)}
                                        className="text-blue-700 hover:text-white hover:bg-blue-800 focus:ring-4 focus:outline-none
                                            focus:ring-blue-300 font-bold rounded-lg text-sm px-5 py-2.5 text-left me-2 mb-2 dark:border-blue-500
                                            dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
                                    >
                                        <i className={(showCalendar ? 'fas fa-eye-slash' : 'fas fa-eye') + ' mr-2'}></i>

                                        {showCalendar ? "Ẩn lịch mở rộng" : "Xem lịch mở rộng"}
                                    </button>
                                    {showCalendar && (
                                        <Calendar
                                            data={Array.prototype.concat(data, dataExam)}
                                            isEventClicked={(id, name) => isEventClicked(id, name)}
                                            isEventChangeMonthClicked={() => {}}
                                            isEventDateClicked={() => {}}
                                        />
                                    )}
                                </TabPanel>
                                <TabPanel>
                                    <div className='py-4 px-2 max-w-md'>
                                        <div>
                                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                                Tên lớp học
                                            </div>
                                            <input
                                                disabled
                                                type='text'
                                                autoComplete='subject'
                                                className='input-custom appearance-none block
														w-full px-3 py-2 border border-gray-300
														placeholder-gray-500 rounded-md
														focus:outline-none focus:ring-1
														focus:ring-blue-700'
                                                value={
                                                    // @ts-ignore

                                                    // NhutTrung
                                                    subjectInfo['name']
                                                }
                                            />
                                        </div>
                                        <div className='mt-2'>
                                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                                Môn học
                                            </div>
                                            <input
                                                disabled
                                                type='text'
                                                className='input-custom appearance-none block
														w-full px-3 py-2 border border-gray-300
														placeholder-gray-500 rounded-md
														focus:outline-none focus:ring-1
														focus:ring-blue-700'
                                                value={
                                                    // @ts-ignore

                                                    // NhutTrung
                                                    subjectDetail['name']
                                                }
                                            />
                                        </div>
                                        <div className='mt-2'>
                                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                                Giảng viên
                                            </div>
                                            <input
                                                disabled
                                                type='text'
                                                className='input-custom appearance-none block
														w-full px-3 py-2 border border-gray-300
														placeholder-gray-500 rounded-md
														focus:outline-none focus:ring-1
														focus:ring-blue-700'
                                                value={
                                                    // @ts-ignore
                                                    teacherInfo['fullName']
                                                }
                                            />
                                        </div>
                                        <div className='mt-2'>
                                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                                Số lượng sinh viên
                                            </div>
                                            <input
                                                disabled
                                                type='text'
                                                className='input-custom appearance-none block
														w-full px-3 py-2 border border-gray-300
														placeholder-gray-500 rounded-md
														focus:outline-none focus:ring-1
														focus:ring-blue-700'
                                                value={
                                                    // @ts-ignore
                                                    subjectInfo['numberOfStudent']
                                                }
                                            />
                                        </div>
                                        <div className='mt-2'>
                                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                                Ngày bắt đầu
                                            </div>
                                            <DatePicker
                                                selected={new Date(subjectTeachingDetail.startDate)}
                                                dateFormat='dd/MM/yyyy'
                                                disabled
                                            />
                                        </div>
                                        <div className='mt-2'>
                                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                                Ngày kết thúc
                                            </div>
                                            <DatePicker
                                                selected={new Date(subjectTeachingDetail.endDate)}
                                                dateFormat='dd/MM/yyyy'
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    {
                                        subjectTeachingExamList.length > 0 ?
                                            <div>
                                                <div className='flex justify-end items-center flex-wrap pt-2 pb-2'>
                                                    <div className='action--item flex justify-start items-end'>
                                                        <div
                                                            className='actions--item mr-3'
                                                            onClick={examExportSubjectStudent}>
                                                            <Button
                                                                label='Xuất danh sách dự thi'
                                                                icon={<i className='fas fa-upload' />}
                                                                color='bg-green-700'
                                                                hoverColor='bg-green-800'
                                                            />
                                                        </div>
                                                        <div
                                                            className='actions--item mr-3'
                                                            onClick={examBySubjectTeachingProcess}>
                                                            <Button
                                                                label='Xuất bảng điểm quá trình'
                                                                icon={<i className='fas fa-upload' />}
                                                                color='bg-green-700'
                                                                hoverColor='bg-green-800'
                                                            />
                                                        </div>
                                                        <div
                                                            className='actions--item'
                                                            onClick={(e) => {
                                                                history.push(`/nhap-diem/${idSubjectTeaching}`);
                                                            }}>
                                                            <Button
                                                                label='Nhập điểm'
                                                                icon={<i className='fas fa-user-edit' />}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> : ''
                                    }

                                    <TableSubjectTeachingExam
                                        data={subjectTeachingExamList}
                                        clicked={openUpdateExam}
                                        gotoViewResultExam={gotoViewResultExam}
                                        gotoResultExam={(e, id) => history.push(`/lich-thi-chi-tiet/${id}`)}
                                        deleteClicked={(e, id) => isDeleteSubjectTeachingExam(id)}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <DragDropInput documentLists={documentLists} subjectId={subjectDetail['id']}
                                                   handleChangeDocument={el => setIsDocumentChange(() => el)}></DragDropInput>
                                </TabPanel>
                                <TabPanel>
                                    <div className="mt-4 mb-4">
                                        <h2 className="text-lg font-semibold mb-4">Nhật ký hành động</h2>
                                        <div className="overflow-x-auto">
                                            <table className="min-w-full divide-y divide-gray-200">
                                                <thead className='bg-gray-50'>
                                                <tr>
                                                    <th className="w-[5%] p-3 text-xs font-medium text-gray-500 uppercase tracking-wider">STT</th>
                                                    <th className="w-[10%] p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ngày</th>
                                                    <th className="w-[5%] p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Thời gian</th>
                                                    <th className="w-[10%] p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hành động</th>
                                                    <th className="w-[40%] p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Chi tiết</th>
                                                    <th className="w-[30%] p-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Người thao tác</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {logs.map((item : any, index) => (
                                                    <tr
                                                        key={item.id}
                                                        className={'hover:bg-gray-100 cursor-pointer bg-' + (item.action === 1 ? 'green-50' : item.action === 2 ? 'yellow-50' : 'red-50')}
                                                    >
                                                        <td className="p-3 border-b text-center">
                                                            {index + 1}
                                                        </td>
                                                        <td className="p-3 border-b text-left">
                                                            {moment(item.creationDate).format('DD/MM/YYYY')}
                                                        </td>
                                                        <td className="p-3 border-b text-left">
                                                            {moment(item.creationDate).format('HH:mm')}
                                                        </td>
                                                        <td className="p-3 border-b text-left">
                                                            <span
                                                                className={
                                                                    "px-2 py-1 rounded-pill text-xs font-medium " +
                                                                    (item.action === 1
                                                                        ? "bg-green-100 text-green-800"
                                                                        : item.action === 2
                                                                            ? "bg-yellow-100 text-yellow-800"
                                                                            : "bg-red-100 text-red-800")
                                                                }
                                                            >
                                                              {getAction(item.action)}
                                                            </span>
                                                        </td>
                                                        <td className="p-3 border-b text-left">
                                                            <span
                                                                className={
                                                                    "px-2 py-1 w-full rounded font-medium " +
                                                                    (item.action === 1
                                                                        ? "bg-green-100 text-green-800"
                                                                        : item.action === 2
                                                                            ? "bg-yellow-100 text-yellow-800"
                                                                            : "bg-red-100 text-red-800")
                                                                }
                                                            >
                                                                {item.recordDesc}
                                                            </span>
                                                        </td>
                                                        <td className="p-3 border-b text-left text-blue-700">
                                                            {item.fullName}
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={modalShowSubjectSchedule}
                aria-labelledby='contained-modal-title-vcenter'
                onHide={() => setModalShowSubjectSchedule(false)}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title id='contained-modal-title-vcenter'>
                        {updateSubjectSchedule
                            ? 'Cập nhật lịch học'
                            : 'Tạo mới lịch học'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        updateSubjectSchedule ? '' :
                            <div className='flex center'>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                    Lặp lại hằng tuần
                                </div>
                                <input
                                    type='checkbox'
                                    className='h-4 w-4 mt-0.5 ml-4'
                                    // @ts-ignore
                                    checked={subjectScheduleTmp.isRepeatedWeekly}
                                    onChange={(e) => {
                                        isRepeatedWeekly_Checked(e);
                                    }}
                                />
                            </div>
                    }
                    <div>
                        <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                            {subjectScheduleTmp.isRepeatedWeekly ? 'Từ ngày' : 'Ngày học'}
                        </div>
                        <DatePicker
                            className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                            selected={new Date(subjectScheduleTmp.startDate)}
                            onChange={(date) => {
                                setSubjectScheduleTmp({
                                    ...subjectScheduleTmp,
                                    startDate: date
                                });
                            }}
                            minDate={new Date(subjectTeachingDetail.startDate)}
                            dateFormat='dd/MM/yyyy'
                        />
                    </div>
                    {
                        !subjectScheduleTmp.isRepeatedWeekly ? '' :
                            <div className='mt-2'>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                    Đến ngày
                                </div>
                                <DatePicker
                                    selected={new Date(subjectScheduleTmp.endDate)}
                                    onChange={(date) => {
                                        setSubjectScheduleTmp({
                                            ...subjectScheduleTmp,
                                            endDate: date
                                        });
                                    }}
                                    minDate={new Date(subjectTeachingDetail.startDate)}
                                    dateFormat='dd/MM/yyyy'
                                />
                            </div>
                    }

                    {rooms && rooms.length > 0 ? (
                        <div className='mt-2'>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Phòng học
                            </div>
                            <select
                                className='input-custom block
												w-full px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                // @ts-ignore
                                value={subjectScheduleTmp.roomId}
                                onChange={(e) => {
                                    setSubjectScheduleTmp({
                                        ...subjectScheduleTmp,
                                        // @ts-ignore
                                        roomId: e.target.value
                                    });
                                }}>
                                {rooms.map((item: any) => {
                                    return (
                                        <option
                                            value={item.id}
                                            key={item.id}>
                                            {item.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    ) : (
                        ''
                    )}
                    <div style={{ paddingTop: '20px' }}>
                        <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                            <div className={'flex flex-row justify-between'}>
                                <div>Giờ bắt đầu</div>
                                <div>
                                    <button className={'btn btn-sm bg-blue-800 text-white mr-1'}
                                            onClick={() => setTimeInput({
                                                ...timeInput,
                                                startTime: '08:00',
                                                endTime: '11:30'
                                            })}>Buổi SA
                                    </button>
                                    <button className={'btn btn-sm bg-yellow-500 text-white mr-1'}
                                            onClick={() => setTimeInput({
                                                ...timeInput,
                                                startTime: '13:30',
                                                endTime: '16:45'
                                            })}>Buổi CH
                                    </button>
                                    <button className={'btn btn-sm bg-green-500 text-white'}
                                            onClick={() => setTimeInput({
                                                ...timeInput,
                                                startTime: '17:00',
                                                endTime: '20:00'
                                            })}>Buổi TỐI
                                    </button>
                                </div>
                            </div>
                        </div>
                        <input
                            name='text'
                            type='time'
                            required
                            className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                            placeholder='Giờ bắt đầu buổi học'
                            onChange={(e) => {
                                setTimeInput({
                                    ...timeInput,
                                    startTime: e.target.value,
                                    endTime: e.target.value == '08:00' ? '11:30' : e.target.value == '13:30' ? '16:45' : timeInput.endTime
                                });
                            }}
                            value={timeInput.startTime}
                        />
                    </div>
                    <div style={{ paddingTop: '20px' }}>
                        <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                            Giờ kết thúc
                        </div>
                        <input
                            name='text'
                            type='time'
                            required
                            className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                            placeholder='Giờ kết thúc'
                            onChange={(e) => {
                                setTimeInput({
                                    ...timeInput,
                                    endTime: e.target.value,
                                    startTime: e.target.value == '11:30' ? '08:00' : e.target.value == '16:45' ? '13:30' : timeInput.startTime
                                });
                            }}
                            min={timeInput.startTime}
                            value={timeInput.endTime}
                        />
                    </div>
                    <div style={{ paddingTop: '20px' }}>
                        <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                            Ghi chú
                        </div>
                        <input
                            name='text'
                            type='text'
                            className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                            placeholder='Ghi chú buổi học'
                            value={subjectScheduleTmp.note}
                            onChange={(e) => {
                                setSubjectScheduleTmp({
                                    ...subjectScheduleTmp,
                                    note: e.target.value
                                });
                            }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ justifyContent: 'space-between' }}>
                    {
                        !updateSubjectSchedule ? '' :
                            <div className={'flex flex-row justify-between'}>
                                { role ?
                                    <div
                                        onClick={() => {
                                            isDeleteSubjectSchedule();
                                        }}>
                                        <Button color={'bg-red-600'} hoverColor={'bg-red-800'}
                                                icon={<i className='fas fa-trash'></i>} label='Xóa buổi học' />
                                    </div>
                                    : ''
                                }
                                <div
                                    onClick={() => {
                                        goAttendance(subjectScheduleTmp);
                                    }}>
                                    <Button color={'bg-green-600'} hoverColor={'bg-green-800'}
                                            icon={<i className='fas fa-check'></i>} label='Điểm danh' />
                                </div>
                            </div>
                    }
                    {role ?
                        <div>
                            <div
                                onClick={() => {
                                    onSaveSubjectSchedule();
                                }}>
                                <Button icon={<i className='fas fa-save'></i>}
                                        label={updateSubjectSchedule ? 'Lưu lại' : 'Lưu & Đóng'} />
                            </div>
                        </div>
                        : ''
                    }
                    {
                        updateSubjectSchedule ? '' :
                            <div>
                                <div
                                    onClick={() => {
                                        onSaveContinueSubjectSchedule();
                                    }}>
                                    <Button icon={<i className='fas fa-save'></i>} label='Lưu & Tiếp tục' />
                                </div>
                            </div>
                    }

                </Modal.Footer>
            </Modal>
            <Modal
                show={modalShowSubjectTeachingExam}
                aria-labelledby='contained-modal-title-vcenter'
                onHide={() => setModalShowSubjectTeachingExam(false)}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title id='contained-modal-title-vcenter'>
                        {updateSubjectTeachingExam
                            ? 'Cập nhật lịch thi'
                            : 'Tạo mới lịch thi'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={'d-flex flex-row flex-wrap'}>
                        <div className={'col-12'}>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Tên lịch thi
                            </div>
                            <input type='text'
                                   className='input-custom block
												w-full px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                   value={subjectTeachingExam.name}
                                   onChange={e => setSubjectTeachingExam({
                                       ...subjectTeachingExam,
                                       name: e.target.value
                                   })}
                            />
                        </div>
                        <div className={'col-12'}>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Loại kỳ thi
                            </div>
                            <select
                                className='input-custom block
												w-full px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                // @ts-ignore
                                value={subjectTeachingExam.type}
                                onChange={(e) => {
                                    setSubjectTeachingExam({
                                        ...subjectTeachingExam,
                                        // @ts-ignore
                                        type: Number.parseInt(e.target.value)
                                    });
                                }}>
                                <option
                                    value={1}>
                                    Thường xuyên - Regular
                                </option>
                                <option
                                    value={2}>
                                    Giữa kỳ - Mid
                                </option>
                                <option
                                    value={3}>
                                    Cuối kỳ - Final
                                </option>
                                <option
                                    value={4}>
                                    Tổng kết - Summary
                                </option>
                            </select>
                        </div>
                        <div className='mt-2 col-12'>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Bộ đề thi
                            </div>
                            <select
                                className='input-custom block
												w-full px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                // @ts-ignore
                                value={subjectTeachingExam.questionSuiteId}
                                onChange={(e) => {
                                    setSubjectTeachingExam({
                                        ...subjectTeachingExam,
                                        questionSuiteId: e.target.value
                                    });
                                }}>
                                <option value={''}>Chưa có bộ đề thi</option>
                                {questionSuite && questionSuite.length > 0
                                    ? questionSuite.map((item: any) => {
                                          const isUsed = usedQuestionSuiteIds.includes(item.id);
                                          const usedByExam = isUsed ? getExamUsingQuestionSuite(item.id) : '';
                                          return (
                                              <option
                                                  value={item.id}
                                                  key={item.id}
                                                  disabled={isUsed}
                                                  style={
                                                      isUsed
                                                          ? {
                                                                color: '#999',
                                                                fontStyle: 'italic',
                                                                backgroundColor: '#f5f5f5'
                                                            }
                                                          : undefined
                                                  }>
                                                  {item.name}
                                                  {isUsed ? ` (Đã dùng cho: ${usedByExam})` : ''}
                                              </option>
                                          );
                                      })
                                    : ''}
                            </select>
                        </div>

                        <div className={'col-12 mt-2'}>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Hình thức thi
                            </div>
                            <select
                                className='input-custom block
                                    w-full px-3 py-2 border border-gray-300
                                    placeholder-gray-500 rounded-md
                                    focus:outline-none focus:ring-1
                                    focus:ring-blue-700'
                                value={subjectTeachingExam.method ?? ''}
                                onChange={(e) => {
                                    setSubjectTeachingExam({
                                        ...subjectTeachingExam,
                                        method: e.target.value === '' ? null : Number.parseInt(e.target.value)
                                    });
                                }}>
                                <option value={''}>-- Chọn hình thức thi --</option>
                                <option value={0}>Khác</option>
                                <option value={1}>Lý thuyết</option>
                                <option value={2}>Thực hành</option>
                                <option value={3}>Lý thuyết & Thực hành</option>
                                <option value={4}>Báo cáo</option>
                            </select>
                        </div>

                        <div className={'col-6 mt-2'}>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Lần thi
                            </div>
                            <input type='number'
                                   min={1}
                                   max={4}
                                   className='input-custom block
												w-full px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                   value={subjectTeachingExam.count}
                                   onChange={e => setSubjectTeachingExam({
                                       ...subjectTeachingExam,
                                       count: Number.parseInt(e.target.value)
                                   })}
                            />
                        </div>
                        {rooms && rooms.length > 0 ? (
                            <div className='mt-2 col-6'>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                    Phòng thi
                                </div>
                                <select
                                    className='input-custom block
												w-full px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                    // @ts-ignore
                                    value={subjectTeachingExam.roomIdDefault}
                                    onChange={(e) => {
                                        setSubjectTeachingExam({
                                            ...subjectTeachingExam,
                                            // @ts-ignore
                                            roomIdDefault: e.target.value
                                        });
                                    }}>
                                    {rooms.map((item: any) => {
                                        return (
                                            <option
                                                value={item.id}
                                                key={item.id}>
                                                {item.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        ) : (
                            ''
                        )}
                        <div className={'col-6'}>
                            <div className='pl-1 mt-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Số câu dễ
                            </div>
                            <input
                                type='number'
                                required
                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                placeholder='Nhập số câu dễ'
                                value={subjectTeachingExam.numOfEasy}
                                onChange={(e) => {
                                    setSubjectTeachingExam({
                                        ...subjectTeachingExam,
                                        numOfEasy: Number.parseInt(e.target.value)
                                    });
                                }}
                            />
                        </div>
                        <div className={'col-6'}>
                            <div className='pl-1 mt-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Số câu trung bình
                            </div>
                            <input
                                type='number'
                                required
                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                placeholder='Nhập số câu trung bình'
                                value={subjectTeachingExam.numOfNormal}
                                onChange={(e) => {
                                    setSubjectTeachingExam({
                                        ...subjectTeachingExam,
                                        numOfNormal: Number.parseInt(e.target.value)
                                    });
                                }}
                            />
                        </div>
                        <div className='col-6'>
                            <div className='pl-1 mt-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Số câu khó
                            </div>
                            <input
                                type='number'
                                required
                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                placeholder='Nhập số câu khó'
                                value={subjectTeachingExam.numOfHard}
                                onChange={(e) => {
                                    setSubjectTeachingExam({
                                        ...subjectTeachingExam,
                                        numOfHard: Number.parseInt(e.target.value)
                                    });
                                }}
                            />
                        </div>
                        <div className='col-6 mt-2'>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Ngày thi
                            </div>
                            <DatePicker
                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                selected={new Date(subjectTeachingExam.dateExam)}
                                onChange={(date) => {
                                    setSubjectTeachingExam({
                                        ...subjectTeachingExam,
                                        dateExam: date
                                    });
                                }}
                                // minDate={new Date()}
                                dateFormat='dd/MM/yyyy'
                            />
                        </div>
                        <div className={'col-12 mt-2'}>
                            <div className={'flex flex-row justify-between py-2'}>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                    Giờ bắt đầu
                                </div>
                                <div>
                                    <button className={'btn btn-sm bg-blue-800 text-white mr-1'}
                                            onClick={() => setTimeInput({
                                                ...timeInput,
                                                startTime: '08:00',
                                                endTime: '11:30'
                                            })}>Buổi SA
                                    </button>
                                    <button className={'btn btn-sm bg-yellow-500 text-white mr-1'}
                                            onClick={() => setTimeInput({
                                                ...timeInput,
                                                startTime: '13:30',
                                                endTime: '16:45'
                                            })}>Buổi CH
                                    </button>
                                    <button className={'btn btn-sm bg-green-500 text-white'}
                                            onClick={() => setTimeInput({
                                                ...timeInput,
                                                startTime: '17:00',
                                                endTime: '20:00'
                                            })}>Buổi TỐI
                                    </button>
                                </div>
                            </div>
                            <input
                                name='text'
                                type='time'
                                required
                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                placeholder='Giờ bắt đầu thi'
                                onChange={(e) => {
                                    setTimeInput({
                                        ...timeInput,
                                        startTime: e.target.value,
                                        endTime: e.target.value == '08:00' ? '11:30' : e.target.value == '13:30' ? '16:45' : timeInput.endTime
                                    });
                                }}
                                value={timeInput.startTime}
                            />
                        </div>
                        <div className={'col-12 mt-2'}>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Giờ kết thúc
                            </div>
                            <input
                                name='text'
                                type='time'
                                required
                                className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                placeholder='Giờ kết thúc'
                                onChange={(e) => {
                                    setTimeInput({
                                        ...timeInput,
                                        endTime: e.target.value,
                                        startTime: e.target.value == '11:30' ? '08:00' : e.target.value == '16:45' ? '13:30' : timeInput.startTime
                                    });
                                }}
                                min={timeInput.startTime}
                                value={timeInput.endTime}
                            />
                        </div>
                        <div className={'col-12'}>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                Ghi chú
                            </div>
                            <input type='text'
                                   className='input-custom block
												w-full px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                   value={subjectTeachingExam.notes}
                                   onChange={e => setSubjectTeachingExam({
                                       ...subjectTeachingExam,
                                       notes: e.target.value
                                   })}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ justifyContent: 'space-between' }}>
                    {
                        !updateSubjectTeachingExam ? '' :
                            <div className={'flex flex-row justify-between'}>
                                <div
                                    onClick={() => {
                                        isDeleteSubjectTeachingExam(subjectTeachingExam.id);
                                    }}>
                                    <Button icon={<i className='fas fa-trash'></i>} label='Xóa buổi thi' />
                                </div>
                                <div
                                    onClick={() => {
                                        goAttendanceExam(subjectTeachingExam);
                                    }}>
                                    <Button color={'bg-green-600'} hoverColor={'bg-green-800'}
                                            icon={<i className='fas fa-check'></i>} label='Điểm danh' />
                                </div>
                            </div>
                    }
                    <div>
                        <div
                            onClick={() => {
                                onSaveSubjectTeachingExam();
                            }}>
                            <Button icon={<i className='fas fa-save'></i>}
                                    label={updateSubjectSchedule ? 'Lưu lại' : 'Lưu & Đóng'} />
                        </div>
                    </div>
                    {
                        updateSubjectTeachingExam ? '' :
                            <div>
                                <div
                                    onClick={() => {
                                        onSaveContinueSubjectTeachingExam();
                                    }}>
                                    <Button icon={<i className='fas fa-save'></i>} label='Lưu & Tiếp tục' />
                                </div>
                            </div>
                    }

                </Modal.Footer>
            </Modal>
            <Modal
                size='lg'
                show={modalShowAddStudent}
                aria-labelledby='contained-modal-title-vcenter'
                onHide={() => setModalShowAddStudent(false)}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title id='contained-modal-title-vcenter'>
                        Danh sách sinh viên
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DialogStudent reloadData={(e) => setChanges(e)} />
                </Modal.Body>
            </Modal>
            <Modal
                show={modalShowAddNotification}
                aria-labelledby='contained-modal-title-vcenter'
                onHide={() => {
                    setModalShowAddNotification(false);
                    setNoti({ message: '', enforceRead: false });
                }}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title id='contained-modal-title-vcenter'>
                        <i className='far fa-bell' /> Thêm thông báo cho môn học
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className='mt-2 mb-3 p-3 flex items-center bg-yellow-50 border border-yellow-200 rounded-md'>
                            <div className='pl-1 text-sm font-bold text-yellow-800 flex items-center'>
                                <i className='fas fa-exclamation-triangle mr-2 text-yellow-600' />
                                Thông báo quan trọng
                            </div>
                            <input
                                name={'enforceRead'}
                                type='checkbox'
                                className='h-5 w-5 mt-0.5 ml-4 cursor-pointer'
                                onChange={(e) => {
                                    setNoti({
                                        ...noti,
                                        // @ts-ignore
                                        enforceRead: e.target.checked
                                    });
                                }}
                                // @ts-ignore
                                checked={noti.enforceRead}
                            />
                        </div>
                        <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                            <i className={'far fa-pencil'} /> Nội dung thông báo
                        </div>
                        <textarea
                            name='text'
                            rows={5}
                            required
                            className='appearance-none block
									w-full px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                            placeholder='Nhập nội dung thông báo'
                            value={noti.message}
                            onChange={(e) => {
                                setNoti({ ...noti, message: e.target.value });
                            }}
                        />
                    </div>
                    <div className='mt-3'>
                        <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                            <i className={'fas fa-tag'} /> Loại thông báo
                        </div>
                        <select
                            value={announcementType}
                            onChange={(e) => setAnnouncementType(Number(e.target.value))}
                            className='appearance-none block
										w-full px-3 py-2 border border-gray-300
										placeholder-gray-500 rounded-md
										focus:outline-none focus:ring-1
										focus:ring-blue-700'
                        >
                            <option value={0}>Học tập</option>
                            <option value={1}>Hoạt động</option>
                            <option value={2}>Dịch vụ</option>
                        </select>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div onClick={() => {
                        setModalShowAddNotification(false);
                        setNoti({ message: '', enforceRead: false });
                    }}>
                        <Button
                            label={'Hủy'}
                            color={'bg-red-800'}
                            hoverColor={'bg-red-900'}
                            icon={<i className='far fa-times-circle' />}
                        />
                    </div>
                    <div
                        onClick={() => {
                            createNotification();
                        }}>
                        <Button
                            color={'bg-green-800'}
                            hoverColor={'bg-green-900'}
                            icon={<i className={'far fa-bell'} />}
                            label={'Tạo mới'}
                        />
                    </div>
                </Modal.Footer>
            </Modal>
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
                deleteItem={deleteItem}
            />
            <ConfirmDialog
                confirmDialog={examConfirmDialog}
                setConfirmDialog={setExamConfirmDialog}
                deleteItem={deleteExamItem}
            />
            <ConfirmDialog
                confirmDialog={confirmDialogAddNotification}
                setConfirmDialog={setConfirmDialogAddNotification}
                deleteItem={addNotificationSubject}
            />
            <ConfirmDialog
                confirmDialog={confirmCreateSubjectSchedule}
                setConfirmDialog={setConfirmCreateSubjectSchedule}
                deleteItem={isCreateSubjectSchdule}
            />
            <ConfirmDialog
                confirmDialog={confirmCreateSubjectExam}
                setConfirmDialog={setConfirmCreateSubjectExam}
                deleteItem={isCreateSubjectTeachingExam}
            />
            <ErrorDialog
                errorDialog={errDialog}
                setErrorDialog={setErrDialog}
            />
        </DefaultLayout>
    );
}

export default Schedule__Subject__Teaching;
